import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";  
  const OurPartners = ({city}) => {  
    const [listings, setListings] = useState([]);
     const [loading, setLoading] = useState(true);
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

     useEffect(() => {
       fetch(`${API}/api/developerlisthome.ashx`, {
         method: "POST",
         headers: {
           "Content-Type": "application/json"
         },
         body: JSON.stringify({ city })
       }) // 🔁 replace URL
         .then((res) => res.json())
         .then((res) => {
           console.log("API Response:", res);
   
           // ✅ Handle different API formats safely
           const result = Array.isArray(res) ? res : res.data;
   
           setListings(result || []);
           setLoading(false);
         })
         .catch((err) => {
           console.error("API Error:", err);
           listings([]);
           setLoading(false);
         });
     },  [city]);
  
    if (loading) return <p>Loading developers...</p>;
  
  return (
    <>
     {listings.map(item => (
    <div className="col-md-3">
          <div className="boxx">
            <Link to={`/developers/${item.url}`}>
              <img src={item.ImagePath+'/w=421,sharpen=1'} alt={item.title} />
            </Link>
          </div>
        </div>
         ))}
    </> 
  );
}

export default OurPartners;
